export default __webpack_public_path__ + "static/icon-23-4-fb5b2b73bc375fbeea37ea8dac8f88b0.png";